import axios from "../../../config/axiosConfig";

const extractoService = {
  getExtractoHistorico: async (fechaInicio, fechaFin) => {
    try {
      const response = await axios.get("/api/extracto-historico", {
        params: { fechaInicio, fechaFin },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener extracto histórico:", error);
      throw error;
    }
  },
  exportarExcel: async (fechaInicio, fechaFin) => {
    const response = await axios.get("/api/extracto-historico/exportar-excel", {
      params: { fechaInicio, fechaFin },
      responseType: "blob",
    });
    return response.data;
  },
};

export default extractoService;
